module.exports = __webpack_public_path__ + "static/media/no-photo2.360de0f5.png";